import { z } from 'zod';
import { UseSchema } from '../../common';

export const model3dCreateDtoSchema = z.object({
  projectEntryId: z.string().uuid().describe('The ID of the project to which the model belongs'),
  fileName: z.string().describe('The name of the file to upload'),
  fileHash: z.string().optional().describe('The hash of file content'),
  fileSize: z.number().describe('The size of the file in bytes'),
  outputs: z
    .array(
      z.object({
        fileName: z.string().describe('The name of the output'),
      }),
    )
    .optional(),
});

@UseSchema(model3dCreateDtoSchema)
export class Model3dCreateDto {}
export interface Model3dCreateDto extends z.infer<typeof model3dCreateDtoSchema> {}
